export * from './profile-detail/profile.detail.component';
export * from './profile-edit/profile.edit.component';




// WEBPACK FOOTER //
// ./src/components/user/index.ts